import { useOrdersListFilterFields } from 'pages/Orders/OrdersList/hooks/useOrdersListFilterFields';
import { useFormContext } from 'react-hook-form';
import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

export const OrdersListFilterChips: React.FC = () => {
  const fields = useOrdersListFilterFields();
  const { watch } = useFormContext();

  const externalErrorWatched = watch('orderProviderExternalError.providerExternalError.reason');

  return (
    <FilterChips
      fields={
        externalErrorWatched ? fields : fields.filter(({ name }) => name !== 'matchRejectReason')
      }
    />
  );
};
